"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Calendar = void 0;
const date_fns_1 = require("date-fns");
const React = __importStar(require("react"));
const react_day_picker_1 = require("react-day-picker");
const pi_1 = require("react-icons/pi");
const utils_1 = require("../../lib/utils");
const Button_1 = require("../Button/Button");
const ButtonBase_1 = require("../Button/ButtonBase");
function Calendar({ className, classNames, showOutsideDays = true, onClickMonth, ...props }) {
    return (React.createElement(react_day_picker_1.DayPicker, { showOutsideDays: showOutsideDays, className: (0, utils_1.cn)("tw-p-2 tw-shadow-none", className), classNames: {
            months: "tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-x-4 sm:tw-space-y-0",
            month: "tw-space-y-4",
            caption: "tw-flex tw-justify-center tw-relative tw-items-center",
            caption_label: "tw-text-md tw-font-semibold tw-text-neutral-600",
            nav: "tw-space-x-1 tw-flex tw-items-center",
            nav_button: (0, utils_1.cn)((0, ButtonBase_1.buttonBaseVariants)({ color: "transparent" }), "tw-h-7 tw-w-7 tw-p-0"),
            nav_button_previous: "tw-absolute tw-left-1",
            nav_button_next: "tw-absolute tw-right-1",
            table: "tw-w-full tw-border-collapse tw-space-y-1",
            head_row: "tw-flex",
            head_cell: "tw-text-neutral-300 tw-rounded-md tw-w-9 tw-font-semibold tw-text-[0.65rem]",
            row: "tw-flex tw-w-full tw-mt-1",
            cell: "tw-h-7 tw-w-9 tw-text-center tw-flex-grow tw-text-xs tw-p-0 tw-relative focus-within:tw-relative focus-within:tw-z-20",
            day: (0, utils_1.cn)((0, ButtonBase_1.buttonBaseVariants)({ color: "grey" }), "tw-h-7 tw-w-9 tw-p-0 tw-font-normal aria-selected:tw-bg-secondary-300 aria-selected:hover:tw-bg-secondary-400 aria-selected:tw-text-neutral-25"),
            day_range_end: "day-range-end",
            day_today: "tw-text-primary-300",
            ...classNames,
        }, components: {
            IconLeft: () => React.createElement(pi_1.PiCaretLeftBold, { className: "tw-h-4 tw-w-4" }),
            IconRight: () => React.createElement(pi_1.PiCaretRightBold, { className: "tw-h-4 tw-w-4" }),
            CaptionLabel: ({ displayMonth }) => (React.createElement(Button_1.Button, { color: "transparent", onClick: onClickMonth }, (0, date_fns_1.format)(displayMonth, "MMM yyyy"))),
        }, ...props }));
}
exports.Calendar = Calendar;
Calendar.displayName = "Calendar";
